<template>
    <div style="width: 100%;scroll-behavior: smooth;">
        <div style="margin-bottom: 15px;width: 1120px;margin: 0 auto;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/', query: {tab: 0} }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/NQI' }">NQI站点</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/NQIDetail' }">站点信息</el-breadcrumb-item>
                <el-breadcrumb-item>淄博市不锈钢产品质量基础设施一站式服务平台</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="top-bottom" style="margin-top: 10px;">
            <img src="../../assets/img/buxiugang/logo.png" style="margin-left: -2px;" alt="">
        </div>
        <!-- <div style="margin: 10px 23%;min-width: 680px;"> -->
        <div style="margin: 0 auto;width: 1120px;">
            <div class="page-container">
                <!-- 政策文件 -->
                <section class="section">
                <div class="section-title">
                    <p class="en-title">POLICY PAPERS</p>
                    <h2 class="cn-title">政策文件</h2>
                </div>
                <div class="list-group">
                    <div class="list-item" v-for="(item, index) in policyList" :key="index" @click="zhengceFile(item.files)">
                      <img class="icon-placeholder" src="../../assets/img/buxiugang/file.png" style="width: 17px;height: 20px;" alt="">
                      <!-- <span class="icon-placeholder"></span> -->
                      <span class="text">{{ item.name }}</span>
                    </div>
                </div>
                </section>

                <!-- 标准 -->
                <section class="section">
                <div class="section-title">
                    <p class="en-title">STANDARD DOCUMENTS</p>
                    <h2 class="cn-title">标准</h2>
                </div>
                <div class="list-group">
                    <div class="list-item with-date" v-for="(item, index) in standardList" :key="index">
                      <div class="left">
                        <!-- <img class="icon-placeholder" src="../../assets/img/buxiugang/bz.png" style="width: 17px;height: 20px;" alt=""> -->
                          <!-- <span class="icon-placeholder h-icon"></span> -->
                        <div style="display: flex;flex-direction: column;line-height: 1.5;">
                          <span class="text" style="font-size: 16px;color: #4a74be;">{{ item.standardNumber }}</span>
                          <span class="text" style="font-size: 11px;color: black;">{{ item.csName }}</span>
                        </div>
                      </div>
                      <div style="display: flex;justify-content: end;width: 200px;justify-content: space-evenly;align-items: center;">
                        <span class="date">{{ item.releaseDate }}</span>
                        <span class="date" style="padding: 7px 10px;background-color: #56a0e3;color: white;font-size: 11px;border-radius: 3px;">{{ item.standardState }}</span>
                        <span class="date" style="padding: 7px 10px;background-color: #409eff;color: white;font-size: 11px;border-radius: 3px;"   @click="openDialog(item)">预览</span> 
                      </div> 
                    </div>
                    <div style="display: flex;justify-content: center;margin-top: 20px;">
                      <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[6, 10, 15, 20]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                      </el-pagination>
                    </div>
                </div>
                </section>

                <!-- 平台服务 -->
                <section class="section">
                <div class="section-title">
                    <p class="en-title">PLATFORM SERVICE SYSTEM</p>
                    <h2 class="cn-title">平台服务</h2>
                </div>
                <div class="service-grid">
                    <div class="service-card" v-for="(item, index) in serviceList" :key="index" @click="getDialog(item)">
                    <div class="card-bg">
                        <!-- 这里可以替换为真实图片 -->
                        <img class="bg-img" :src="require(`@/assets/img/buxiugang/item${index + 1}.png`)" alt="">
                        <!-- <div class="card-text">{{ item.name }}</div> -->
                    </div>
                    </div>
                </div>
                </section>

                <!-- 企业标杆 -->
                <section class="section">
                <div class="section-title">
                    <p class="en-title">CORPORATE BENCHMARK</p>
                    <h2 class="cn-title">企业标杆</h2>
                </div>
                <div class="benchmark-grid">
                    <div class="benchmark-card" v-for="(item, index) in benchmarkList" :key="index">
                    <div class="card-logo">
                        <!-- Logo占位 -->
                        <img :src="getUrl(item.picture)" style="width: 180px;height: 90px;padding: 10px;" alt="">
                        <!-- <div class="logo-placeholder">NCSS</div> -->
                    </div>
                    <div class="card-info">
                        <h4 class="name">{{ item.name }}</h4>
                        <p class="info">联系方式：{{ item.phone }}</p>
                        <p class="info">地址：{{ item.address }}</p>
                    </div>
                    </div>
                </div>
                </section>
            </div>
        </div>
        <ServiceDialog
          :visible.sync="dialogShow"
          :header-img-url="imgPath"
          :title="title"
          :contentList="contentList"
          :desc="desc"
        />
        <StandardDetailDialog :dialog-visible.sync="showDialog" :source-data="nowItem" @close="handleDialogClose" />
    </div>
</template>
<script>
  import { Server,httpurl } from "@/server";
  //引入axios插件
  import axios from "axios";
  import ServiceDialog from './buxiugangDialog.vue'
  import StandardDetailDialog from './taocibiaozhun.vue'
  export default {
    name: 'PolicyStandardPage',
    components: { ServiceDialog, StandardDetailDialog },
  data() {
    return {
      policyList: [],//Array(5).fill({ name: '氢能产业发展中长期规划（2021-2035年）' })
      standardList: [],
      serviceList: [
        { 
          name: '检验检测服务', 
          img: '', 
          contentList:[
            "化学成分分析:采用直读光谱法、手工化学分析法测定金属元素含量。",
            "机械性能测试:检测不锈钢材料力学性能、硬度及冲击韧性等关键指标。",
            "耐腐蚀性能评价:通过盐雾试验、晶间腐蚀试验，测试产品耐腐蚀性。",
            "微观组织分析:进行金相检验，评估材料内部结构。",
            "工艺适应性检测:管材扩口、板材弯曲、焊接接头无损探伤检测。",
            "食品接触安全检测:食品接触用不锈钢产品有害元素检测。",
            "焊接工艺评定:对焊接工艺进行综合测试、评定。"
          ], 
          desc:'平台提供全面、精准的检测服务，确保不锈钢产品符合国家标准及行业规范，涵盖以下核心项目' 
        },
        { 
          name: '质量鉴定及失效分析', 
          img: '', 
          contentList:["通过全方位检验分析，找出失效根源，提出改进建议;同时，利用先进设备和测试方法，在产品认证、事故调查、质量争议中，对产品的性能、可靠性、安全性进行评估，提供权威、公正的质量鉴定意见。"], 
          desc:'' 
        },
        { 
          name: '标准宣贯及制定', 
          img: '', 
          contentList:["根据企业需求定期开展国家、行业标准宣贯会，解读最新法规要求。协助企业制定企业标准、团体标准，推动行业技术协同与竞争力提升。"], 
          desc:'' 
        },
        { 
          name: '计量服务', 
          img: '', 
          contentList:["平台提供专业计量技术支持，对各类量具等设备进行定期检定校准;为企业提供计量管理体系指导及资质认证咨询。"], 
          desc:'' 
        },
        { 
          name: '不锈钢产品相关认证认可', 
          img: '', 
          contentList:["平台协助企业通过ISO 9001(质量管理体系)、ISO14001(环境管理体系)、ISO45001(职业健康安全)等体系认证;协助企业完成碳足迹核算、产品生命周期评价(LCA)，获取绿色产品认证等。"], 
          desc:'' 
        },
        { 
          name: '技术咨询', 
          img: '', 
          contentList:[
            "依托淄博市检验检测计量研究总院的技术团队和资源，平台提供全方位技术支持:生产工艺优化技术难题攻关市场准入指导、技术培训服务",
            "平台通过检测+标准+计量一站化服务模式，帮助企业缩短产品研发周期、降低质量风险，同时提供技术培训和市场准入支持，助力企业突破国际贸易技术壁垒，打造淄博不锈钢区域品牌。"
          ], 
          desc:'' 
        }
      ],
      benchmarkList: [],
      dialogShow: false,
      // 替换成你的头部图片路径
      imgPath: require('@/assets/img/buxiugang/dialog.png'),
      title:'',
      showDialog: false,

      sspt:1,
      nowItem:{},
      currentPage:1,
      pageNo:1,
      pageSize:6,
      total:0
    }
  },
  mounted() {
    this.getData()
  },
  methods:{
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.getIndustryStandardList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNo = val
      this.getIndustryStandardList()
    },
    zhengceFile(url) {
      url = this.$previewUrl + url
      window.open('','_blank')
      .document.write(`<iframe src="${url}" style="width:100%;height:100vh;border:none;"></iframe>`);
    },
    openDialog(item) {
      this.nowItem = item
      this.showDialog = true;
      
    },
    handleDialogClose() {
      console.log('弹窗关闭回调');
    },
    getIndustryStandardList() {
      Server.getIndustryStandardList({sspt:this.sspt,pageSize:this.pageSize,pageNo:this.pageNo}).then((res) => {
          console.log(res);
          if(res.success) {
            console.log(res);
            this.total = res.result.total
            this.standardList = res.result.records || []
            
          }
        })
    },
    getData() {
        this.getIndustryStandardList()
        Server.getIndustryPolicyList({sspt:this.sspt,pageSize:-1}).then((res) => {
          console.log(res);
          if(res.success) {
            console.log(res);
            this.policyList = res.result.records || []
          }
        })
        Server.getIndustryBenchmarkList({sspt:this.sspt,pageSize:-1}).then((res) => {
          console.log(res);
          if(res.success) {
            console.log(res);
            this.benchmarkList = res.result.records || []
          }
        })
    },
    getUrl(file) {
      return this.$previewUrl + file
    },
    getDialog(item) {
      this.contentList = item.contentList
      this.desc = item.desc
      this.title = item.name
      this.dialogShow = true
    }
  }
}
</script>

<style scoped>
.page-container {
  padding-top: 10px;
  max-width: 1100px;
  margin: 0 auto;
  background: #ffffff;
  padding: 20px 0;
}
.section {
  margin-bottom: 40px;
}
.section-title {
  text-align: center;
  margin-bottom: 20px;
}
.en-title {
  font-size: 20px;
  color: #ddd;
  margin: 0 0 4px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.cn-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-top: -8px;
}
.list-group {
  background: #fff;
}
.list-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f5f5f5;

  background-color: #f5f7fa;
  margin: 5px 20px;
}
.list-item:last-child {
  border-bottom: none;
}
.icon-placeholder {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: #d8e4f8;
  border-radius: 2px;
  margin-right: 8px;
}
.icon-placeholder.h-icon {
  background: #c9d8f0;
  border-radius: 50%;
}
.text {
  font-size: 14px;
  color: #333;
}
.list-item.with-date {
  justify-content: space-between;
}
.list-item.with-date .left {
  display: flex;
  align-items: center;
}
.date {
  font-size: 12px;
  color: #666;
}
/* 平台服务网格 */
.service-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 0 10px;
}
.service-card {
  overflow: hidden;
}
.card-bg {
  position: relative;
  width: 100%;
  height: 140px;
  background: #e9edf5;
}
.bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.8;
}
.card-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 14px;
  text-align: center;
  text-shadow: 0 0 4px rgba(0,0,0,0.3);
}
/* 产业标杆 */
.benchmark-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  padding: 0 10px;
}
.benchmark-card {
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid #eee;
}
.logo-placeholder {
  width: 40px;
  height: 40px;
  background: #e0e7f3;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #3366aa;
  margin-right: 12px;
}
.name {
  font-size: 14px;
  margin: 0 0 8px;
}
.info {
  font-size: 12px;
  color: #666;
  margin: 4px 0;
}
</style>